import React from 'react';
import { Button } from '../components/ui/button';
import Link from 'next/link';
import { GearIcon } from '@radix-ui/react-icons';

interface ManageConsignorGroupsButtonProps {
}

const ManageConsignorGroupsButton = ({ }: ManageConsignorGroupsButtonProps) => {
    return (
        <Link href={`/consignors/groups`}>
            <Button variant="outline">
                <GearIcon className="mr-2" />
                Manage Groups
            </Button>
        </Link>
    );
};

export default ManageConsignorGroupsButton;